module.exports = __webpack_public_path__ + "img/logo.467dba3e.png";